// PA Review Queue: the routes and the sidebar rows of `wealth.pa-dealing.review-queue` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.pa-dealing.review-queue',
    routes: [
        {
            frontend: 'comply',
            path: 'pa-dealing-review',
            lazy: () => import('@/pages/comply/pa-dealing-review/page'),
        },
        {
            frontend: 'comply',
            path: 'pa-dealing-review/requests/:id',
            lazy: () => import('@/pages/comply/pa-dealing-review/request/page'),
        },
    ],
    nav: [
        // SEP-264 - the Compliance management of PA Dealing. The request detail
        // `/comply/pa-dealing-review/requests/:id` falls under the queue row.
        {
            frontend: 'comply',
            key: 'pa-dealing-review',
            label: 'PA Review Queue',
            href: '/comply/pa-dealing-review',
            icon: 'ClipboardCheck',
            group: 'pa-dealing',
            order: 510,
        },
    ],
});
